<template>

    <form v-on:submit.prevent="done()" class="modal-card box" style="min-width: 750px; width: auto;">
        
        <section class="modal-card-body">
            
            <div class="buttons is-pulled-right">
                <router-link :to="`/projects/${project.id}/connect`">
                    <b-button @click="$emit('close')">
                        <i class="fa fa-link"></i>&nbsp;
                        API
                    </b-button>
                </router-link>&nbsp;

                <router-link :to="`/projects/${project.id}/connect`">
                    <b-button @click="$emit('close')">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"/></svg>
                        Connect
                    </b-button>
                </router-link>&nbsp;
            </div>

            
            <Predict :apiKey="getApiKey()" :currentUser="currentUser" :project="project" :modelId="modelId"/>
            <!-- <b-tabs type="is-boxed" v-model="tabItem" animateInitially>
                <b-tab-item key="play" value="play">
                        <template #header>
                            <h4 class="title is-5">
                                <i class="fa fa-play"></i> Inference</h4>
                        </template>
                        <Playground :isBatch="false" :apiKey="getApiKey()" :inferenceUrl="getInferenceUrl()" :currentUser="currentUser" :models="project.models" :project="project"/>
                    </b-tab-item>
                    <b-tab-item key="batch" value="batch">
                        <template #header>
                            <h4 class="title is-5">
                                <i class="fa fa-file"></i> Batch (CSV file)</h4>
                        </template>
                        <Playground :isBatch="true" :apiKey="getApiKey()" :inferenceUrl="getInferenceUrl()" :currentUser="currentUser" :models="project.models" :project="project"/>
                    </b-tab-item>
                    <b-tab-item key="curl" value="curl">
                        <template #header>
                            <h4 class="title is-5">
                                Inference API</h4>
                        </template>
                        <b-notification style="background: #222;" :closable="false">
                <code style="color: #f1f1f1; background: #222;">$ curl --request POST \<br>
--url {{getInferenceUrl()}} \<br>
--header 'content-type: application/json' \<br>
--header 'x-api-key: {{getApiKey()}}' \<br>
--data '{"text": "hello world"}'</code>
                </b-notification>
                    </b-tab-item> 
            </b-tabs>-->
            
            
<!--             
            <b-button
                v-if="labelingMode"
                type="is-primary"
                label="Done"
                @click="$emit('close')"
                expanded />
            <b-button v-else
                tag="button"
                native-type="submit"
                label="Done"
                type="is-primary"
                expanded /> -->
                
    
        </section>
        
    </form>
</template>
<script>
import Predict from "@/dashboard/Project/PredictPreview.vue";

export default {
    props: ["project", "currentUser", "modelId"],
     name: "Inference",
     data: function() {
    return {
        all_users_api_key: 'GcD8CJgm1i4ELinYrXLbt4pAMi5gXptN9FuB5MwI'
      }},
      components: {
        Predict
      },
      created() {
      },
      computed: {

      },
      methods: {
         getApiKey(){
            if(this.currentUser && "apiKey" in this.currentUser && this.currentUser.apiKey != undefined){
              return this.currentUser.apiKey
            } else {
              return this.all_users_api_key
            }
         },
        },
    }
    </script>